import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IMeetingRequestInfoByTokenPayload } from '@app-store/slices/meetingRequests/infoByToken'

interface TaskAction extends Action {
    payload: IMeetingRequestInfoByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.infoByToken

function* meetingRequestInfoByTokenSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/meeting-requests/meeting-info`, {
            params: {
                token: payload.token
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* meetingRequestInfoByTokenSaga(): any {
    yield takeLatest<TaskAction>(onRequest, meetingRequestInfoByTokenSagaTask)
}

export default meetingRequestInfoByTokenSaga
